import React from 'react';

enum InitializationStatus {
    Failure = 0,
    Success = 1,
}

interface PropsType {
  children: JSX.Element
}

/**
  * Simple class to manage the application initialization metric.
  *
  * Note this is meant as a demonstration of how to use the initialization metric, and
  * is almost certainly inadequate for a more complex application.
  *
  * It waits for itself to be mounted (if it is the outermost component that means all of
  * its children are rendered and mounted by React, though are not necessarily fully rendered
  * in the browser), then waits for the translations to be ready.
  *
  * In your actual application, you are likely not fully initialized until you have completed
  * your initial REST calls.  You will need to either integrate that logic here, or else move
  * the initialization metric elsewhere.
  *
  * For applications using a state manager (e.g. Redux) it may make more sense to determine if
  * your application is initialized from that layer instead.
  */
export class AppInitWrapper extends React.Component<PropsType, {}> {
    componentDidMount() {
        // Publish component initialization metrics
    }

    // No componentDidCatch: catching here and re-throwing made React report
    // the root ErrorBoundary's componentStack from this wrapper instead of
    // from the component that crashed.

    render() {
        return this.props.children;
    }
}

export default AppInitWrapper;
